import { Routes } from "@angular/router";

import { ORDER_ROUTES } from "@features/orders/orders.routes";
import { CATALOG_ROUTES } from "@features/catalog/catalog.routes";
import { LOAN_ROUTES } from "@features/loans/loans.routes";
import { TASK_ROUTES } from "@features/task/task.routes";
import { REPORT_ROUTES } from "@features/reports/reports.routes";
import { AuthGuard } from "@app/guards/auth.guard";
import { AttorneyRestrictedGuard } from "@app/guards/attorney-restricted.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "",
    loadComponent: () =>
      import("@app/shared/components/layout/shell/shell.component").then(
        (m) => m.ShellComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "order",
        children: ORDER_ROUTES,
      },
      {
        path: "catalog",
        canActivate: [AttorneyRestrictedGuard],
        children: CATALOG_ROUTES,
      },
      {
        path: "loan",
        canActivate: [AttorneyRestrictedGuard],
        children: LOAN_ROUTES,
      },
      {
        path: "task",
        canActivate: [AttorneyRestrictedGuard],
        children: TASK_ROUTES,
      },
      {
        path: "reports",
        canActivate: [AttorneyRestrictedGuard],
        children: REPORT_ROUTES,
      },
    ],
  },
  {
    path: "login",
    loadComponent: () =>
      import("@app/shared/components/login/login.component").then(
        (m) => m.LoginComponent,
      ),
  },
];
